import Select from "../plugins/Select";

export const empty = function (elem) {
    return (
        elem === '' ||
        elem === 0 ||
        elem === false ||
        elem === null ||
        elem === undefined ||
        elem.length === 0 ||
        (typeof elem === 'object' && Object.keys(elem).length === 0)
    );
};

export function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
        charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    if ($(document).find('#' + result).length !== 0)
        return makeid(length);

    return result;
}

export function preparePhone(phone) {
    return phone.replace(/\s/g, '')
                .replace(/-/g, '')
                .replace(/\(/g, '')
                .replace(/\)/g, '');
}

export function preg_quote(str, delimiter) { // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/preg_quote/
    // original by: booeyOH
    // improved by: Ates Goral (https://magnetiq.com)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Brett Zamir (https://brett-zamir.me)
    // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
    //   example 1: preg_quote("$40")
    //   returns 1: '\\$40'
    //   example 2: preg_quote("*RRRING* Hello?")
    //   returns 2: '\\*RRRING\\* Hello\\?'
    //   example 3: preg_quote("\\.+*?[^]$(){}=!<>|:")
    //   returns 3: '\\\\\\.\\+\\*\\?\\[\\^\\]\\$\\(\\)\\{\\}\\=\\!\\<\\>\\|\\:'

    return (str + '')
        .replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
}


export function clear(form) {

    form.find('input:not([type=hidden]), textarea').val('');
    form.find('select').val('');
    Select.get(form).updateAll();

}

/**
 * @function
 * Truncate site's protocol, last slash
 * @param {string=} site string
 * @return {string|undefined}
 */
export function prepareSite(site ) {
    const reg = new RegExp('https?:\/\/([^\/]+)\/?$');
    if (site) {
        return site.match(reg).length ? site.match(reg)[1] : site;
    }

    return '';
}